import gql from 'graphql-tag';
import { PeriodPlanResultFields } from './fragments/PeriodPlanResult';

export default function(uniqKey = '') {
  const key = 'getPeriodPlanResult' + uniqKey;
  return {
    key,
    query: gql`

  query ${key} ($periodPlanResultId: ID!) {
    getPeriodPlanResult(id:$periodPlanResultId){
      ${PeriodPlanResultFields}
    }
  }
  `,
  };
}
